import React from 'react';
import { WHATSAPP_URL } from '../data/seminar';
type CtaButtonProps = {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  children,
  size = 'md',
  className = ''
}: CtaButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-10 py-5 text-sm sm:text-base tracking-[0.2em]' : 'px-8 py-4 text-xs sm:text-sm tracking-[0.2em]';
  return <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center justify-center rounded-full bg-gold font-sans font-semibold uppercase text-navy shadow-soft transition-colors duration-200 hover:bg-gold-light focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40 active:translate-y-px ${sizeClasses} ${className}`} data-id="element-31" data-mp="qk251hb084ka">
      {children}
    </a>;
}